import React from "react";
import {
  NavLink,
  Switch,
  Route,
  BrowserRouter
} from "react-router-dom";
import { Helmet } from "react-helmet";


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Cases from "./components/cases";
import Information from "./components/information";
import Gallery from "./components/gallery";



function Navigation() {


  return (
    <div>
      <Information />
      <Cases />
      <Gallery />
    </div>
  );
}

export default Navigation;
